import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "../ui/Icon";
import { useTabStore, MAX_TABS } from "../../lib/tabStore";
import "./TabBar.css";

/**
 * UYGULAMA İÇİ SEKME ÇUBUĞU.
 *
 * ── URL hâlâ tek doğruluk kaynağı (Faz 1) ──
 * Sekme listesi gezinmeyi YÖNLENDİRMEZ, gezinmeyi İZLER: `useLocation` her değiştiğinde
 * ilgili sekme açılır/öne getirilir. Bunun kritik faydası, sekmelerin YALNIZ menü
 * tıklamasıyla değil; bildirime tıklayınca, derin bağlantıyla, yetkisiz sayfadan
 * yönlendirilince ve tarayıcının geri tuşuyla da doğru çalışması. Tıklamaları tek tek
 * yakalamaya çalışsaydık bu yolların her biri ayrı bir hata olurdu.
 *
 * Faz 2'de sayfalar sekme başına mount edilecek; bu bileşenin sözleşmesi değişmeyecek.
 */
export function TabBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const tabs = useTabStore((s) => s.tabs);
  const activeId = useTabStore((s) => s.activeId);
  const open = useTabStore((s) => s.open);
  const close = useTabStore((s) => s.close);
  const closeOthers = useTabStore((s) => s.closeOthers);
  const stripRef = useRef<HTMLDivElement | null>(null);

  // Gezinme → sekme. Yol zaten açıksa yeni sekme AÇILMAZ, var olan öne gelir.
  useEffect(() => {
    open(pathname);
  }, [pathname, open]);

  // Aktif sekme görünür alanın dışında kalmışsa (çok sekme + dar ekran) kaydır.
  useEffect(() => {
    const el = stripRef.current?.querySelector<HTMLElement>(".tabbar-tab.active");
    el?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [activeId, tabs.length]);

  if (tabs.length === 0) return null;

  const onClose = (e: React.MouseEvent, id: string) => {
    e.stopPropagation(); // sekmeyi kapatırken aynı tıklama onu ÖNE de getirmesin
    const target = close(id);
    if (target) navigate(target);
  };

  return (
    <div className="tabbar" role="tablist" aria-label="Açık sayfalar">
      <div className="tabbar-strip" ref={stripRef}>
        {tabs.map((t) => {
          const isActive = t.id === activeId;
          return (
            <div
              key={t.id}
              role="tab"
              tabIndex={0}
              aria-selected={isActive}
              className={`tabbar-tab${isActive ? " active" : ""}`}
              title={t.title}
              onClick={() => navigate(t.path)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") { e.preventDefault(); navigate(t.path); }
                // Orta tık yerine klavyeden kapatma: Delete
                if (e.key === "Delete") { e.preventDefault(); const to = close(t.id); if (to) navigate(to); }
              }}
              // Orta tıkla kapatma — tarayıcı sekmelerindeki alışkanlık.
              onAuxClick={(e) => { if (e.button === 1) onClose(e, t.id); }}
              onContextMenu={(e) => {
                if (tabs.length < 2) return;
                e.preventDefault();
                closeOthers(t.id);
                navigate(t.path);
              }}
            >
              <Icon name={t.icon} size={13} className="tabbar-ic" />
              <span className="tabbar-lbl">{t.title}</span>
              <button
                type="button"
                className="tabbar-x"
                aria-label={`${t.title} sekmesini kapat`}
                onClick={(e) => onClose(e, t.id)}
              >
                <Icon name="x" size={11} />
              </button>
            </div>
          );
        })}
      </div>
      {tabs.length >= MAX_TABS ? (
        <span className="tabbar-full" title={`En fazla ${MAX_TABS} sekme açık kalabilir — yeni sekme açılınca en uzun süredir kullanılmayan kapanır.`}>
          {tabs.length}/{MAX_TABS}
        </span>
      ) : null}
    </div>
  );
}
